// Utils
import { getInboxState } from '../../../common/elements/utils/elementPropertyUtils';
import { InboxState } from '../../../common/boards/boardConstants';

const isInboxState = (inboxState) => (element) => getInboxState(element) === inboxState;

export const isInboxOpen = isInboxState(InboxState.OPEN);
export const isInboxClosed = isInboxState(InboxState.CLOSED);
